import { formatDate2 } from '../../utils/formatters';
import { formatDateLong } from '../../utils/formatters';
import { formatPrice } from '@/utils';
import { Multiselect } from '../../components/Common/index';
import axios from "axios";

export default {
    name: 'PerformancePage',
    props: {
        performance: Array,
    },
    components: { Multiselect },
    data() {
        return {
            trades: this.performance.length,
            wins: 0,
            winspercent: 0,
            losses: 0,
            breakeven: 0,
            overallpercent: 0,
            overallgain: 0,
            percentpertrade: 0,
            initcash: 0,
            finalcash: 0,
            ipt: 0,
            tradetotal: 0,
            rows: [],
            shownRows: [],
            lastDate: null,
            showAll: false,
            perPage: 50,
            currentPage: 1,
            today: new Date(Date.now()),
            selectedServices: [],
            services: [],
            showSelect: false,
            title: "Live Trading Room",
            serviceFromQuery: ""
        }
    },
    async beforeMount() {
        await this.getServices();
        this.showSelect = window.admin;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.serviceFromQuery = urlParams.get('service');
        let totalTrades = 0;
        if (!this.serviceFromQuery){
            this.selectedServices = this.services;
            this.title = "Live Trading Room";
            this.initcash = window.initialCapitalAll;
            this.finalcash = window.initialCapitalAll;
        } else {
            //const services = this.services.filter(x=>x.name == service.toUpperCase());
            this.selectedServices = this.services.filter(x=>x.name == "EPT");
            this.title = "Earnings Service";
            this.initcash = window.initialCapitalEPT;
            this.finalcash = window.initialCapitalEPT;
        }
        const selectedServicesIds = this.selectedServices.map(x=>x.id);
        this.rows = this.performance.filter(r=> selectedServicesIds.includes(r.service)).map(row => {
            const risk = row.action == 1 ? row.enter - row.stop : row.stop - row.enter;
            const pl = row.action == 1 ? row.exit - row.enter : row.enter - row.exit;
            let percent = 0;
            let service = row.service == null ? 0 : row.service;
            if (risk > 0) {
                percent = (pl / risk) * 100;
            }

            if (pl > 0) {
                this.wins++;
            }
            else if (pl < 0) {
                this.losses++;
            }
            else if (pl == 0) {
                this.breakeven++;
            }

            totalTrades++;
            this.overallpercent += percent;
            this.overallgain = this.overallgain + pl;

            let isOption = row.stockticker.includes("Option");

            if (isOption) {
                this.ipt = row.enter * 100 * window.optionsCount;
            }
            else {
                this.ipt = row.enter * window.sharesCount;
            }
            this.initsize = Math.round(this.ipt / row.enter);

            this.traderesult = this.initsize * pl;
            this.tradetotal += this.traderesult;

            return {
                stockticker: row.stockticker,
                opendate: row.opendate,
                closedate: row.closedate,
                enter: row.enter,
                stop: row.stop,
                exit: row.exit,
                risk: parseFloat(Math.round(risk * 100) / 100).toFixed(2),
                pl: pl,
                percent: parseFloat(Math.round(percent * 100) / 100).toFixed(2),
                action: row.action == 1 ? 'LONG' : row.action == -1 ? 'SHORT' : 'UNKNOWN',
                service: service,
                tradeid: row.tradeid
            }
        });
        this.finalcash += this.tradetotal;
        if(totalTrades > 0) {
            this.percentpertrade = (this.overallpercent / totalTrades);
        }
        let total = this.wins + this.losses + this.breakeven;
        this.winspercent = total != 0 ? (this.wins / total) * 100 : 0;
        this.lastDate = new Date(this.performance[0].closedate);
    },
    methods: {
        calcPerformance(val) {
            this.selectedServices = val;
            if (!val || val.length == 0){
                this.selectedServices = this.services;
            }
            const selectedServicesIds = this.selectedServices.map(x=>x.id);
            this.wins= 0;
            this.winspercent= 0;
            this.losses= 0;
            this.breakeven = 0;
            this.overallpercent = 0;
            this.overallgain = 0;
            this.percentpertrade = 0; 
            let totalTrades = 0;           
             if (!this.serviceFromQuery){
                this.initcash = window.initialCapitalAll;
                this.finalcash = window.initialCapitalAll;
            } else {
                this.initcash = window.initialCapitalEPT;
                this.finalcash = window.initialCapitalEPT;
            }
            this.ipt = 0;
            this.tradetotal = 0;
            this.rows = this.performance.filter(r=> selectedServicesIds.includes(r.service)).map(row => {
                const risk = row.action == 1 ? row.enter - row.stop : row.stop - row.enter;
                const pl = row.action == 1 ? row.exit - row.enter : row.enter - row.exit;
                let percent = 0;
                let service = row.service == null ? 0 : row.service;
                if (risk > 0) {
                    percent = (pl / risk) * 100;
                }
    
                if (pl > 0) {
                    this.wins++;
                }
                else if (pl < 0) {
                    this.losses++;
                }
                else if (pl == 0) {
                    this.breakeven++;
                }
    
                totalTrades++;
                this.overallpercent += percent;
                this.overallgain = this.overallgain + pl;
    
                let isOption = row.stockticker.includes("Option");
    
                if (isOption) {
                    this.ipt = row.enter * 100 * window.optionsCount;
                }
                else {
                    this.ipt = row.enter * window.sharesCount;
                }
                this.initsize = Math.round(this.ipt / row.enter);
    
                this.traderesult = this.initsize * pl;
                this.tradetotal += this.traderesult;
    
                return {
                    stockticker: row.stockticker,
                    opendate: row.opendate,
                    closedate: row.closedate,
                    enter: row.enter,
                    stop: row.stop,
                    exit: row.exit,
                    risk: parseFloat(Math.round(risk * 100) / 100).toFixed(2),
                    pl: pl,
                    percent: parseFloat(Math.round(percent * 100) / 100).toFixed(2),
                    action: row.action == 1 ? 'LONG' : row.action == -1 ? 'SHORT' : 'UNKNOWN',
                    service: service,
                    tradeid: row.tradeid
                }
            });
            this.finalcash += this.tradetotal;
            if(totalTrades > 0) {
                this.percentpertrade = (this.overallpercent / totalTrades);
            }
            let total = this.wins + this.losses + this.breakeven;
            this.winspercent = total != 0 ? (this.wins / total) * 100 : 0;
        },
        async setTradeService() {
            axios.post('/api/performance/set-service', {
                tradeId: event.target.parentElement.id,
                service: event.target.value
            })
                .then(function (response) {
                })
                .catch(function (error) {
                });
        },
        async getServices() {
            const e = await axios.get('/api/performance/services');
            this.services = e.data.payload;
            this.selectedServices = e.data.payload;
        }
    }

}